import React, { useEffect, useLayoutEffect, useState } from "react";
import { FormInput } from "../components/FormInput";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { queryIndustryList, queryLocaleList, queryCountryList } from "../utility/service/register-service";
import { checkDpSuccess, getFormErrorMessage, getLocale } from "../utility/service/tool-service";
import { useParams } from "react-router-dom";

const RegisterStep3 = ({
  isExistCompany = false,
  register,
  errors,
  inputCheckKeyDown,
  control,
  setValidForm,
  setValue,
}) => {
  const { t } = useTranslation();
  const [industryList, setIndustryList] = useState([]);
  const { issuer } = useParams();
  const [localeList, setLocaleList] = useState([]);
  const [countryList, setCountryList] = useState([]);

  //取得行業別下拉清單
  const axios_queryIndustryList = () => {
    queryIndustryList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.industryList;
        setIndustryList(data);
      }
    });
  };

  // 國家下拉選單
  const axios_queryCountryList = () => {
    queryCountryList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.countryList;
        setCountryList(data);
        // 設定預設值為台灣(TW)
        setValue("country", "TW");
      }
    });
  };

  const axios_queryLocaleDropdown = () => {
    queryLocaleList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.localeList;
        setLocaleList(data);
      }
    });
  };

  useEffect(() => {
    if (isExistCompany === false) {
      // 註冊主帳號才要call 行業別清單
      axios_queryIndustryList();
      axios_queryLocaleDropdown();
      axios_queryCountryList();
      let _locale = "";
      if (getLocale().indexOf("-") > -1) {
        _locale = getLocale().split("-");
      } else {
        _locale = getLocale(); //有些語系沒有-只有前綴故需另外判斷 2024/03/01
      }
      _locale = Array.isArray(_locale) ? `${_locale[0].toLowerCase()}-${_locale[1]}` : _locale.toLowerCase();
      if (_locale === "vi-VN") {
        setValue("locale", "vi");
      } else {
        setValue("locale", _locale);
      }
    }
  }, []);

  return (
    <>
      <div className="col-12 font-semibold">{t("organData")}</div>
      <div className="col-12">
        <FormInput
          withLabel={true}
          register={register}
          errors={errors}
          id="taxIdNum"
          labelText={t("company_num")}
          type="text"
          disabled={true}
        />
      </div>
      <div className="col-12">
        <FormInput
          labelClass="required"
          withLabel={true}
          register={register}
          errors={errors}
          id="companyName"
          labelText={t("organName")}
          type="text"
          disabled={isExistCompany === true}
          enterClick={inputCheckKeyDown}
          rules={setValidForm("companyName")}
        />
      </div>

      {/* 主帳戶註冊需顯示 子帳戶不須顯示 */}
      {isExistCompany === false && (
        <>
          <div className="col-12">
            <FormInput
              withLabel={true}
              register={register}
              errors={errors}
              id="companyAddress"
              labelText={t("address")}
              type="text"
              rules={setValidForm("companyAddress")}
              disabled={isExistCompany === true}
              enterClick={inputCheckKeyDown}
            />
          </div>
          <div className="col-12">
            <FormInput
              withLabel={true}
              labelClass="required"
              register={register}
              errors={errors}
              id="companyLeader"
              labelText={t("companyLeader")}
              type="text"
              enterClick={inputCheckKeyDown}
              rules={setValidForm("companyLeader")}
            />
          </div>
          <div className="col-12">
            <FormInput
              withLabel={true}
              labelClass="required"
              register={register}
              errors={errors}
              id="companyEmail"
              labelText={t("companyEamil")}
              type="text"
              enterClick={inputCheckKeyDown}
              rules={setValidForm("companyEmail")}
            />
          </div>
          {/* 行業別下拉 industryCode */}
          <div className="col-12">
            <label htmlFor="industryCode" className="form-label required">
              {t("industry")}
            </label>
            <Controller
              name="industryCode"
              control={control}
              rules={setValidForm("industryCode")}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="industryName"
                  optionValue="industryCode"
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="industryCode"
                  control={control}
                  options={industryList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
            {getFormErrorMessage(errors, "industryCode")}
          </div>
          {/* 國家 */}
          <div className="col-12">
            <label className={`form-label required`}>{t("country")}</label>
            <Controller
              name="country"
              control={control}
              rules={setValidForm("country")}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="countryName"
                  optionValue="country"
                  value={field.value}
                  defaultValue={""}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  placeholder={t("plz_chs")}
                  options={countryList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
            {getFormErrorMessage(errors, "country")}
          </div>
          {/* use language */}
          <div className="col-12">
            <label htmlFor="industryCode" className="form-label required">
              {t("useLanguage")}
            </label>
            <Controller
              name="locale"
              control={control}
              rules={setValidForm("locale")}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="localeName"
                  optionValue="locale"
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  options={localeList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
        </>
      )}

      <div className="col-12 font-semibold">{t("accountProfile")}</div>
      <div className="col-12">
        <FormInput
          labelClass="required"
          withLabel={true}
          register={register}
          errors={errors}
          id="userName"
          labelText={t("user_name")}
          type="text"
          rules={setValidForm("userName")}
          enterClick={inputCheckKeyDown}
        />
      </div>
      {/* <div className='col-12'>
            <FormInput
                labelClass="required"
                withLabel={true}
                register={register}
                errors={errors}
                id="userPhone"
                labelText={t("tel")}
                type="text"
                rules={setValidForm('userPhone')}
                enterClick={inputCheckKeyDown}     
            />
        </div> */}
      <div className="col-12">
        <FormInput
          disabled={issuer === "GOOGLE"}
          labelClass="required"
          withLabel={true}
          register={register}
          errors={errors}
          id="userEmail"
          labelText={t("user_email")}
          type="email"
          rules={setValidForm("userEmail")}
          enterClick={inputCheckKeyDown}
        />
      </div>
    </>
  );
};

export default RegisterStep3;
